module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Adiciona seu respectivo projeto",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo Projeto")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "how-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exclui(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }, {
      key: "proposal.entity.cnpj",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), (_vm.state === 'FORM') ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "name": "frmAddPrj"
    }
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "Projeto"
    }
  }, [_vm._v("Projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projetoNome),
      expression: "projetoNome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projetoNome",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projetoNome = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.escolhido(_vm.projetoNome)
      }]
    }
  }, _vm._l((_vm.projetoNome), function(i) {
    return _c('option', {
      attrs: {
        "label": i.proposal.idProjectErp + ' - ' + i.proposal.name
      },
      domProps: {
        "value": i.id
      }
    })
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tabela.entity),
      expression: "tabela.entity"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "disabled": true,
      "id": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.tabela.entity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tabela, "entity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "cnpj"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "cnpj",
      "id": "cnpj",
      "type": "text",
      "mask": ['##.###.###/####-##']
    },
    model: {
      value: (_vm.tabela.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.tabela, "cnpj", $$v)
      },
      expression: "tabela.cnpj"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Salva o cadastro",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(_vm.frmAddPrj)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "uib-tooltip": "Cancela a edição"
    },
    on: {
      "click": function($event) {
        return _vm.onCancel(_vm.frmAddPrj)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancel")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ce2df61!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/projetos.vue
// module id = 1853
// module chunks = 2